<template>
  <div
    class="attachments-list pa-0"
    :class="in_creating ? 'main__light_green mt-6' : ''">
    <template
      v-for="(fileItem, n) in files">
      <DocumentListItem
        :key="`file-${n}`"
        :in_creating="in_creating"
        :show-history.sync="showHistory[n]"
        :small="small"
        :value="fileItem">
        <template #buttons>
          <template
            v-if="change && !fileItem.title.endsWith('html') && fileItem.fileId">
            <TooltipedBtn
              v-if="fileItem.isActive"
              data-qa="btn-canceled-file"
              :disabled=" loading || fileItem.loading || disabled"
              icon="canceled-file"
              small-btn
              style="order: 1"
              :text="$t('Tenders.Cancel')"
              @click="changeStateFile(n)"/>
            <import-dialog
              :apply="() => changeFile(fileItem)"
              :create-file-handler="createFileHandler"
              :files.sync="new_file"
              files-types
              first_btn_text="Common.Replace"
              only_one
              :subtitle="$t('Tenders.ChoseNewDoc')"
              :title="$t('Tenders.ChangeDoc', {item: fileItem.title})">
              <template #activator="{ open }">
                <TooltipedBtn
                  data-qa="btn-edit-file"
                  :disabled="loading || fileItem.loading || disabled"
                  icon="change-file"
                  small-btn
                  style="order: 2"
                  :text="$t('Tenders.ChangeDoc', {item: ''})"
                  @click="open"/>
              </template>
            </import-dialog>
          </template>
          <TooltipedBtn
            v-if="can_view && fileItem.key &&
              available_types.some(type => type == fileItem.getFileExtension)
              && fileItem.getFileSize <= 62914560
              && ((newEndpoints && fileItem.fileId) || !newEndpoints)"
            data-qa="btn-show-file"
            :disabled="loading || fileItem.loading || disabled"
            icon="eye"
            small-btn
            style="order: 3"
            :text="$t('Tenders.DocumentView')"
            @click="showFile(fileItem)"/>
          <TooltipedBtn
            v-if="fileItem && fileItem.downloader && ((newEndpoints && fileItem.fileId) || !newEndpoints)"
            data-qa="btn-download-file"
            :disabled="loading || fileItem.loading || disabled || fileItem.error"
            icon="download"
            small-btn
            style="order: 4"
            :text="$t('Tenders.Download')"
            @click="save(fileItem)"/>
          <TooltipedBtn
            v-if="!fileItem.deleted && (in_creating || can_delete)"
            data-qa="btn-delete-file"
            :disabled="loading || fileItem.loading || disabled"
            icon="delete"
            small-btn
            style="order: 5"
            :text="$t('Purchasing.Remove')"
            @click="removeFile(n, fileItem)"/>
          <TooltipedBtn
            v-else-if="fileItem.deleted && (in_creating || can_delete)"
            data-qa="btn-delete-file"
            :disabled="loading || fileItem.loading || disabled"
            icon="repeat"
            small-btn
            style="order: 5"
            :text="$t('Common.Restore')"
            @click="restoreFile(n, fileItem)"/>
        </template>
      </DocumentListItem>
      <div
        v-show="fileItem && fileItem.versions && showHistory[n]"
        :key="`version-${n}`">
        <DocumentListItem
          v-for="(version, versionIndex) in fileItem.versions"
          :key="`version-${versionIndex}`"
          history
          :in_creating="in_creating"
          :small="small"
          :value="version">
          <template #buttons>
            <TooltipedBtn
              v-if="(version.key) &&
                available_types.some(type => type == version.getFileExtension )
                && version.getFileSize <= 62914560"
              data-qa="btn-show-file"
              :disabled="loading || version.loading || disabled"
              icon="eye"
              small-btn
              style="order: 1"
              :text="$t('Tenders.DocumentView')"
              @click="showFile(version)"/>
            <TooltipedBtn
              v-if="version && version.downloader"
              data-qa="btn-download-file"
              :disabled="loading || version.loading || disabled"
              icon="download"
              small-btn
              style="order: 2"
              :text="$t('Tenders.Download')"
              @click="save(version)"/>
          </template>
        </DocumentListItem>
      </div>
      <sDivider
        v-if="in_creating"
        :key="n + 'divider'"/>
    </template>
    <DialogDocumentView
      :dialog.sync="dialog.show"
      :file="dialog.fileItem"
      :new-endpoints="newEndpoints"/>
  </div>
</template>
<script>
// TODO: import-dialog нельзя импортировать. Компоненты уходят в цикл, т.к. используются друг в друге
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import DocumentListItem from 'components/common/blocks/DocumentListItem.vue'
import DialogDocumentView from 'components/common/dialogs/DialogDocumentView.vue'

import FilesApi from '@/api/filesApi'
const files_api = new FilesApi()

import { TenderFile } from '@/types/commonFile.js'

export default {
  name: 'documentList',
  data() {
    return {
      dialog: {
        show: false,
        fileItem: null,
      },
      loading: false,
      // not_available_types: [ 'zip', 'rar', '7z', 'gzip', 'djvu' ],
      available_types: [
        'html', 'pdf',
        'png', 'jpeg', 'jpg', 'bmp', 'gif' , // img
        'rtf', 'csv', 'tiff' , // iframe
        'xls', 'xlsx', 'xlsb', 'xlsm',  //Excel
        'doc', 'docx', 'docm', 'dotm', 'dotx',  //Word
        'ppt', 'pptx', 'ppsx', 'pps', 'pptm', 'potm', 'ppam', 'potx', 'ppsm'  //PowerPoint
      ],
      new_file: [],
      showHistory: [],
    }
  },
  computed: {
    files: {
      get() {
        return this.attachments
      },
      set(value) {
        this.$emit('update:attachments', value )
      }
    },
  },
  methods: {
    showFile(fileItem) {
      this.dialog.fileItem = fileItem
      this.dialog.show = true
    },
    changeStateFile(index) {
      if (!this.files[index]) {
        return
      }
      const functionOk = () => {
        files_api.changeStatusDocument({
          status: this.files[index].isActive ? 'NOT_ACTIVE' : 'ACTIVE',
          tenderId: this.item.tenderId,
          documentId: this.files[index].fileId
        })
          .then((response) => {
            if (response) {
              this.files[index].isActive = !this.files[index].isActive
              this.files[index].dateModified = new Date()
            }
          })
          .finally(() => {
            this.$Modal.remove()
          })
      }

      this.$Modal.confirm({
        title: `${this.$t('Tenders.Cancel')}?`,
        content: this.$t('Tenders.CancelDocument', [this.files[index].title]),
        closable: true,
        okText: this.$t('Tenders.Yes'),
        cancelText: this.$t('Tenders.No'),
        dangerouslyUseHTMLString: true,
        loading: true,
        width: 455,
        onOk: functionOk,
      })
    },
    async changeFile(item) {
      this.loading = true
      await item.changeFile(this.new_file[0])
        .then(async (result) => {
          this.$log_info('result', result)
          this.$forceUpdate()

          const oldFile = this.$_.cloneDeep(this.files.find(file => file.fileId === item.fileId))
          const newFile = this.$_.cloneDeep(this.new_file[0])
          if (!newFile) {
            this.$notice.error({
              title: this.$t('Common.ErrorTitle'),
              message: this.$t('Tenders.FileNotSelected'),
              duration: 10,
            })
            return
          }

          oldFile.isActive = false
          oldFile.dateModified = new Date()
          newFile.created = new Date()
          newFile.dateModified = null
          newFile.isActive = true
          newFile.versions = []
          //newFile.fileId= TODO: если не заполним, не будет замены
          //newFile.key= TODO: если не заполним, не будет просмотра
          oldFile.versions?.forEach(version => {
            newFile.versions.push(version)
          })
          oldFile.versions = []
          newFile.versions.unshift(oldFile)

          this.files.push(newFile)
          this.$emit('update:attachments', this.files.filter(file => file.fileId != item.fileId))
        })
        .catch(error => {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: error?.message || '',
            duration: 10,
          })
          this.loading = false
          this.new_file = []
        })
        .finally(() => {
          this.loading = false
          this.new_file = []
        })
    },
    async save(item) {
      this.loading = true
      if (this.newEndpoints) {
        item.downloader()
          .then((response) => {
            let url = URL.createObjectURL(response.data)
            let a = document.createElement('a')
            a.setAttribute('href', url)
            a.setAttribute('download', item.title)
            a.click()
          })
          .finally(() => {
            this.$forceUpdate()
            this.loading = false
          })
        return
      }
      await item.saveFile().finally(() => {
        this.$forceUpdate()
        this.loading = false
      })
    },
    createFileHandler(file) {
      return new TenderFile(this.item.tenderId,
        null,
        null,
        file,
        file.name || file.title,
        file.size,
        this.documentType)
    },
    restoreFile(n, file) {
      this.$emit('restoreFile', {n, file, restore: true})
    },
    async removeFile(n, file) {
      if (this.externalDelete) {
        this.$emit('deleteFile', {n, file})
        return
      }
      this.loading = true
      if (file.fileId) {
        await file.deleteFile()
          .then(() => {
            // eslint-disable-next-line vue/no-mutating-props
            this.attachments.splice(n, 1)
          })
          .catch(res => this.$log_error(res))
      } else {
        // eslint-disable-next-line vue/no-mutating-props
        this.attachments.splice(n, 1)
      }
      this.$emit('deleteFile', {n, file})
      this.loading = false

    },
  },
  components: {
    TooltipedBtn,
    DocumentListItem,
    DialogDocumentView
  },
  props: {
    attachments: Array,
    small: Boolean,
    in_creating: Boolean,
    can_delete: Boolean,
    can_view: {
      type: Boolean,
      default: true
    },
    change: Boolean,
    item: Object,
    disabled: Boolean,
    /**
     * Тип документов (отдельные ендпоинты)
     */
    documentType: String,
    newEndpoints: Boolean,
    /**
    * Внешнее удаление файла
    */
    externalDelete: Boolean, 
  },
}
</script>
<style lang="scss" scoped>
.attachments-list {
  max-height: 450px;
  overflow: auto;
  color: var(--black-color);;
  .error {
    border:  1px solid red !important
  }
  &__document-view {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
  }
}
</style>
